"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUUID = getUUID;
exports.delayFunc = delayFunc;
exports.formatDate = formatDate;
exports.insertDom = insertDom;
exports.getReallyPX = getReallyPX;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

function getUUID() {
  var d = Date.now();
  var uuid = 'hxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16); // eslint-disable-next-line

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

function delayFunc(callback, ms) {
  var timer = setTimeout(function () {
    if (timer) {
      clearTimeout(timer);
      callback();
    }
  }, ms);
}

function formatDate(_date) {
  var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  if (!_date) {
    return '';
  }

  var date = new Date(parseInt(_date, 10));
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  var format = _format;

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, date.getFullYear().toString().substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach(function (k) {
    if (new RegExp("(".concat(k, ")")).test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr(o[k].toString().length));
    }
  });
  return format;
}

var divDom = document.createElement('div');

function insertDom(parent) {
  var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var _index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

  divDom.innerHTML = html;
  var htmlDom = divDom.childNodes[0];
  var index = _index === -1 ? parent.childNodes.length : _index;
  parent.insertBefore(htmlDom, parent.childNodes[index]);
}

var baseFontSize = document.getElementsByTagName('html')[0].style.fontSize.replace(/px/g, '');

function getReallyPX(px) {
  return px / 75 * baseFontSize;
}